import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { registerParentUser } from './actions';
import RegistrationForm from './RegistrationForm';
import { Redirect } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import RegistrationSteps from '../common/components/RegistrationSteps';
import ReduxBlockUi from 'react-block-ui/redux';
import { REGISTER_PARENT_REQUEST, REGISTER_PARENT_SUCCESS, REGISTER_PARENT_FAILURE } from './actions';
import { PARENT_FETCH_REQUEST, PARENT_FETCH_SUCCESS, PARENT_FETCH_FAILURE } from '../dashboard/actions';
import queryString from 'query-string';
import analyticsTracker from '../common/services/analyticsTracker';
import moment from 'moment-timezone';

class Register extends React.Component {
	componentDidMount() {
		analyticsTracker.trackEvent('Lead');
	}

	render() {
		const { individualConsultation } = this.props;
		const { from } = this.props.location.state || {
			from: {
				pathname: individualConsultation ? '/individual-consultation/booking/child' : '/booking/child',
				search: this.props.parent.children.length > 0 ? '?select=true' : '?add=true'
			}
		};

		if (this.props.isAuthenticated && this.props.parent.id > 0) {
			return <Redirect to={from} />;
		}

		const { t, city, centerId, timeZones, localTimeZone, enableUserTimeZone } = this.props;
		
		const initialValues = {
			city: city, centerId: centerId,
			timeZone: localTimeZone
		};

		return (
			<Row>
				<Col sm={12}>
					<ReduxBlockUi block={[PARENT_FETCH_REQUEST, REGISTER_PARENT_REQUEST]} unblock={[PARENT_FETCH_FAILURE, PARENT_FETCH_SUCCESS, PARENT_FETCH_FAILURE, REGISTER_PARENT_SUCCESS, REGISTER_PARENT_FAILURE]}>
						<div className='contact-form'>
							<h1>{t('FO_PageTitle_Registration')}</h1>
							<div style={{ marginBottom: 40 }}>
								<RegistrationSteps currentStep={1} />
							</div>
							<RegistrationForm onSubmit={this.props.registerParentUser}
								titleTypes={this.props.titleTypes}
								referralSourceTypes={this.props.referralSourceTypes}
								cities={this.props.cities}
								termsAndConditions={this.props.franchisor.termsAndConditions}
								photoConsent={this.props.franchisor.photoConsent}
								requireAddress={this.props.franchisor.requireAddress}
								requirePostcode={this.props.franchisor.requirePostcode}
								countryCode={this.props.franchisor.countryCode}
								initialValues={initialValues}
								from={from}
								timeZones={timeZones}
								enableUserTimeZone={enableUserTimeZone}
							/>
						</div>
					</ReduxBlockUi>
				</Col>
			</Row>
		);
	}
}

Register.propTypes = {
	isAuthenticated: PropTypes.bool,
	location: PropTypes.object,
	registerParentUser: PropTypes.func
};

const mapStateToProps = (state, ownProps) => {
	const { auth, lookups: { titleTypes, referralSourceTypes, timeZones }, entities: { centers }, configuration: { franchisor }, booking: { centerId }, parent } = state;

	const cities = [...new Set(Object.keys(centers).map(key => centers[key].city))];	// distinct list of cities with centers

	const city = centerId && centers[centerId] ? centers[centerId].city : '';
	const { individualConsultation } = queryString.parse(ownProps.location.search);
	const localTimeZone = moment.tz.guess(true);

	return {
		...auth,
		titleTypes,
		referralSourceTypes,
		cities,
		franchisor,
		city,
		centerId,
		parent,
		individualConsultation: individualConsultation && individualConsultation.toLowerCase() === "true",
		timeZones,
		localTimeZone: timeZones && timeZones.find(x => x.name === localTimeZone) && localTimeZone,
		enableUserTimeZone: franchisor && franchisor.enableUserTimeZone
	};
};

export default connect(mapStateToProps, {
	registerParentUser
})(withTranslation()(Register));